import WarmUpPage from '../views/WarmUpPage.vue';
import AccessDenied from '../views/AccessDenied.vue';
import NotFound from '../views/NotFound.vue';
import { redirectToLegacy } from './router-business';
import { ModuleIdEnum } from '../enums/moduleId';
import { useCashAdvanceStore } from '../stores/cashAdvance';
import { storeToRefs } from 'pinia';
import { useReadyWageHomeStore } from '../stores/readyWageHome';
import { useReadyCashViewStatementsStore } from '../stores/readyCashViewStatements';
import { useReadyCashHomeStore } from '../stores/readyCashHome';

export default [
  {
    path: '/',
    name: 'home',
    meta: { navTitle: 'ReadyCash', pageName: 'Home', auth: true },
  },

  {
    path: '/warmup',
    name: 'warmup',
    component: WarmUpPage,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: '404' },
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    component: AccessDenied,
    meta: { title: 'Access Denied | HR Hub', auth: false },
  },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    meta: { title: 'Not Found | HR Hub', auth: false },
  },
  {
    path: '/route-to-v1',
    name: 'route-to-v1',
    beforeEnter: (to) => {
      redirectToLegacy(to.query.redirectTo);
    },
    meta: { title: 'Route to v1 | HR Hub', auth: false },
  },
  {
    path: '/readycash',
    name: 'readycash-main',
    redirect: { name: 'readycash-cash-advances' },
    meta: {
      navTitle: 'ReadyCash',
      pageName: 'ReadyCash',
    },
  },
  {
    path: '/readycash/home',
    name: 'readycash-home',
    meta: {
      navTitle: 'ReadyCash',
      pageName: 'ReadyCash Home',
      auth: true,
    },
    components: {
      default: () => import('../layouts/FintechBaseLayoutPage.vue'),
    },
    beforeEnter: (to, from, next) => {
      const readyCashStore = useReadyCashHomeStore();
      const { LD_ReadyCashHome } = storeToRefs(readyCashStore);
      const cashAdvanceStore = useCashAdvanceStore();
      const { hasReadyCash } = storeToRefs(cashAdvanceStore);
      if (!hasReadyCash.value || !LD_ReadyCashHome.value) {
        next({ name: 'home' });
      } else {
        next();
      }
    },
  },
  {
    path: '/readycash/cash-advances',
    name: 'readycash-cash-advances',
    meta: {
      navTitle: 'ReadyCash',
      pageName: 'Cash Advances',
      auth: true,
      moduleId: ModuleIdEnum.attendanceLogs,
    },
    components: {
      default: () => import('../layouts/FintechBaseLayoutPage.vue'),
    },
    beforeEnter: (to, from, next) => {
      const cashAdvanceStore = useCashAdvanceStore();
      const { hasReadyCash, isReadyCashAdmin } = storeToRefs(cashAdvanceStore);
      if (!hasReadyCash.value || !isReadyCashAdmin.value) {
        next({ name: 'home' });
      } else {
        next();
      }
    },
  },
  {
    path: '/readycash/view-statements',
    name: 'readycash-view-statements',
    meta: {
      navTitle: 'ReadyCash',
      pageName: 'View Statements',
      auth: true,
      moduleId: ModuleIdEnum.attendanceLogs,
    },
    components: {
      default: () => import('../layouts/FintechBaseLayoutPage.vue'),
    },
    beforeEnter: (to, from, next) => {
      const cashAdvanceStore = useCashAdvanceStore();
      const RCViewStatementsStore = useReadyCashViewStatementsStore();
      const { hasReadyCash, isReadyCashAdmin } = storeToRefs(cashAdvanceStore);
      const { LD_ViewStatements } = storeToRefs(RCViewStatementsStore);

      if (
        !hasReadyCash.value ||
        !isReadyCashAdmin.value ||
        !LD_ViewStatements.value
      ) {
        next({ name: 'home' });
      } else {
        next();
      }
    },
  },
  {
    path: '/readywage',
    name: 'readywage-main',
    redirect: { name: 'readywage-home' },
    meta: {
      navTitle: 'ReadyWage',
      pageName: 'ReadyWage',
    },
  },
  {
    path: '/readywage/transaction-list',
    name: 'readywage-transaction-list',
    meta: {
      navTitle: 'ReadyWage',
      pageName: 'Transaction List',
      auth: true,
    },
    components: {
      default: () => import('../layouts/FintechBaseLayoutPage.vue'),
    },
    beforeEnter: (to, from, next) => {
      const readyWageStore = useReadyWageHomeStore();
      const { isReadyWageHomeOn, hasReadyWage, isReadyWageAdmin } =
        storeToRefs(readyWageStore);

      if (hasReadyWage.value && isReadyWageAdmin.value) {
        next();
      } else if (
        hasReadyWage.value &&
        !isReadyWageAdmin.value &&
        isReadyWageHomeOn.value
      ) {
        next({ name: 'readywage-home' });
      } else {
        next({ name: 'home' });
      }
    },
  },
  {
    path: '/readywage/home',
    name: 'readywage-home',
    meta: {
      navTitle: 'ReadyWage',
      pageName: 'ReadyWage Home',
      auth: true,
    },
    components: {
      default: () => import('../layouts/FintechBaseLayoutPage.vue'),
    },
    beforeEnter: (to, from, next) => {
      const readyWageStore = useReadyWageHomeStore();
      const { isReadyWageHomeOn, hasReadyWage, isReadyWageAdmin } =
        storeToRefs(readyWageStore);

      if (!hasReadyWage.value) {
        next({ name: 'home' });
      } else if (!isReadyWageHomeOn.value) {
        if (isReadyWageAdmin.value) {
          next({ name: 'readywage-transaction-list' });
        } else {
          next({ name: 'home' });
        }
      } else {
        next();
      }
    },
  },
  {
    path: '/readywage/view-statements',
    name: 'readywage-view-statements',
    meta: {
      navTitle: 'ReadyWage',
      pageName: 'View Statements',
    },
  },
];
